import { CALL_API } from '../middleware/ApiMiddleware';

export const VIOLATIONS_FETCH_REQUEST = 'VIOLATIONS_FETCH_REQUEST';
export const VIOLATIONS_FETCH_SUCCESS = 'VIOLATIONS_FETCH_SUCCESS';
export const VIOLATIONS_FETCH_FAILURE = 'VIOLATIONS_FETCH_FAILURE';

export const VIOLATION_FETCH_REQUEST = 'VIOLATION_FETCH_REQUEST';
export const VIOLATION_FETCH_SUCCESS = 'VIOLATION_FETCH_SUCCESS';
export const VIOLATION_FETCH_FAILURE = 'VIOLATION_FETCH_FAILURE';

export const VIOLATION_CREATE_REQUEST = 'VIOLATION_CREATE_REQUEST';
export const VIOLATION_CREATE_SUCCESS = 'VIOLATION_CREATE_SUCCESS';
export const VIOLATION_CREATE_FAILURE = 'VIOLATION_CREATE_FAILURE';

export const VIOLATION_EDIT_REQUEST = 'VIOLATION_EDIT_REQUEST';
export const VIOLATION_EDIT_SUCCESS = 'VIOLATION_EDIT_SUCCESS';
export const VIOLATION_EDIT_FAILURE = 'VIOLATION_EDIT_FAILURE';

export const VIOLATION_EDIT_SEQUENCE_REQUEST = 'VIOLATION_EDIT_SEQUENCE_REQUEST';
export const VIOLATION_EDIT_SEQUENCE_SUCCESS = 'VIOLATION_EDIT_SEQUENCE_SUCCESS';
export const VIOLATION_EDIT_SEQUENCE_FAILURE = 'VIOLATION_EDIT_SEQUENCE_FAILURE';

export const ACTIVE_VIOLATIONS_FETCH_REQUEST = 'ACTIVE_VIOLATIONS_FETCH_REQUEST';
export const ACTIVE_VIOLATIONS_FETCH_SUCCESS = 'ACTIVE_VIOLATIONS_FETCH_SUCCESS';
export const ACTIVE_VIOLATIONS_FETCH_FAILURE = 'ACTIVE_VIOLATIONS_FETCH_FAILURE';

export const EDIT_DEFAULT_COMPLY_BY_DAYS_REQUEST = 'EDIT_DEFAULT_COMPLY_BY_DAYS_REQUEST';
export const EDIT_DEFAULT_COMPLY_BY_DAYS_SUCCESS = 'EDIT_DEFAULT_COMPLY_BY_DAYS_SUCCESS';
export const EDIT_DEFAULT_COMPLY_BY_DAYS_FAILURE = 'EDIT_DEFAULT_COMPLY_BY_DAYS_FAILURE';

export const GET_DEFAULT_COMPLY_BY_DAYS_REQUEST = 'GET_DEFAULT_COMPLY_BY_DAYS_REQUEST';
export const GET_DEFAULT_COMPLY_BY_DAYS_SUCCESS = 'GET_DEFAULT_COMPLY_BY_DAYS_SUCCESS';
export const GET_DEFAULT_COMPLY_BY_DAYS_FAILURE = 'GET_DEFAULT_COMPLY_BY_DAYS_FAILURE';

export const FETCH_FREQUENT_VIOLATIONS_REQUEST = 'FETCH_FREQUENT_VIOLATIONS_REQUEST';
export const FETCH_FREQUENT_VIOLATIONS_SUCCESS = 'FETCH_FREQUENT_VIOLATIONS_SUCCESS';
export const FETCH_FREQUENT_VIOLATIONS_FAILURE = 'FETCH_FREQUENT_VIOLATIONS_FAILURE';
export const CLEAR_FREQUENT_VIOLATIONS = 'CLEAR_FREQUENT_VIOLATIONS';
export const CLEAR_ACTIVE_VIOLATIONS = 'CLEAR_ACTIVE_VIOLATIONS';

export const FETCH_VIOLATION_LIST_REQUEST = 'FETCH_VIOLATION_LIST_REQUEST';
export const FETCH_VIOLATION_LIST_SUCCESS = 'FETCH_VIOLATION_LIST_SUCCESS';
export const FETCH_VIOLATION_LIST_FAILURE = 'FETCH_VIOLATION_LIST_FAILURE';

export const VIOLATION_SEARCH_REQUEST = 'VIOLATION_SEARCH_REQUEST';
export const VIOLATION_SEARCH_SUCCESS = 'VIOLATION_SEARCH_SUCCESS';
export const VIOLATION_SEARCH_FAILURE = 'VIOLATION_SEARCH_FAILURE';

const configViolationBaseURL = 'xerce/config/violations';
const defaultComplyByDaysBaseURL = 'xerce/config/default-comply-by-days';
const xerceViolationBaseURL = 'xerce/violations';

export const fetchViolations = (params?: IViolationFetchParams) => ({
  [CALL_API]: {
    endpoint: configViolationBaseURL,
    method: 'get',
    authenticated: true,
    params,
    types: [VIOLATIONS_FETCH_REQUEST, VIOLATIONS_FETCH_SUCCESS, VIOLATIONS_FETCH_FAILURE],
    hideLoadingWidget: true,
  },
});

export const fetchViolation = (violationId: number) => ({
  [CALL_API]: {
    endpoint: `${configViolationBaseURL}/${violationId}`,
    method: 'get',
    authenticated: true,
    types: [VIOLATION_FETCH_REQUEST, VIOLATION_FETCH_SUCCESS, VIOLATION_FETCH_FAILURE],
  },
});

export const createViolation = (violation: IConfigViolationRequest) => ({
  [CALL_API]: {
    endpoint: configViolationBaseURL,
    method: 'post',
    authenticated: true,
    body: violation,
    types: [VIOLATION_CREATE_REQUEST, VIOLATION_CREATE_SUCCESS, VIOLATION_CREATE_FAILURE],
  },
});

export const editViolation = (violationId: number, violation: IConfigViolationRequest) => ({
  [CALL_API]: {
    endpoint: `${configViolationBaseURL}/${violationId}`,
    method: 'put',
    authenticated: true,
    body: violation,
    types: [VIOLATION_EDIT_REQUEST, VIOLATION_EDIT_SUCCESS, VIOLATION_EDIT_FAILURE],
  },
});

export const editViolationSequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${configViolationBaseURL}/sequence`,
    method: 'put',
    authenticated: true,
    body: { sequence },
    types: [VIOLATION_EDIT_SEQUENCE_REQUEST, VIOLATION_EDIT_SEQUENCE_SUCCESS, VIOLATION_EDIT_SEQUENCE_FAILURE],
  },
});

export const getDefaultComplyByDays = () => ({
  [CALL_API]: {
    endpoint: defaultComplyByDaysBaseURL,
    method: 'get',
    authenticated: true,
    types: [GET_DEFAULT_COMPLY_BY_DAYS_REQUEST, GET_DEFAULT_COMPLY_BY_DAYS_SUCCESS, GET_DEFAULT_COMPLY_BY_DAYS_FAILURE],
  },
});

export const editDefaultComplyByDays = (defaultComplyByDays: number) => ({
  [CALL_API]: {
    endpoint: defaultComplyByDaysBaseURL,
    method: 'put',
    authenticated: true,
    body: { defaultComplyByDays },
    types: [
      EDIT_DEFAULT_COMPLY_BY_DAYS_REQUEST,
      EDIT_DEFAULT_COMPLY_BY_DAYS_SUCCESS,
      EDIT_DEFAULT_COMPLY_BY_DAYS_FAILURE,
    ],
  },
});

export const fetchActiveViolations = (params: IXerceViolationRequestParams, hideLoadingWidget: boolean = true) => ({
  [CALL_API]: {
    endpoint: xerceViolationBaseURL,
    method: 'get',
    authenticated: true,
    params,
    types: [ACTIVE_VIOLATIONS_FETCH_REQUEST, ACTIVE_VIOLATIONS_FETCH_SUCCESS, ACTIVE_VIOLATIONS_FETCH_FAILURE],
    hideLoadingWidget,
  },
});

export const clearActiveViolations = () => ({
  type: CLEAR_ACTIVE_VIOLATIONS,
});

export const fetchFrequentViolations = () => ({
  [CALL_API]: {
    endpoint: `${xerceViolationBaseURL}/frequent-violations`,
    method: 'get',
    authenticated: true,
    types: [FETCH_FREQUENT_VIOLATIONS_REQUEST, FETCH_FREQUENT_VIOLATIONS_SUCCESS, FETCH_FREQUENT_VIOLATIONS_FAILURE],
  },
});

export const clearFrequentViolations = () => ({
  type: CLEAR_FREQUENT_VIOLATIONS,
});

export const fetchViolationList = (hideLoadingWidget: boolean = false) => ({
  [CALL_API]: {
    endpoint: `${configViolationBaseURL}/list`,
    method: 'get',
    authenticated: true,
    types: [FETCH_VIOLATION_LIST_REQUEST, FETCH_VIOLATION_LIST_SUCCESS, FETCH_VIOLATION_LIST_FAILURE],
    hideLoadingWidget,
  },
});

export const searchViolations = (search: string, abortSignal: AbortSignal = null) => {
  const params = {
    ...(search && { search }),
  };

  // TODO: Implement search functionality with abort capability

  return {
    [CALL_API]: {
      endpoint: xerceViolationBaseURL,
      method: 'get',
      authenticated: true,
      params,
      types: [VIOLATION_SEARCH_REQUEST, VIOLATION_SEARCH_SUCCESS, VIOLATION_SEARCH_FAILURE],
      hideLoadingWidget: true,
      abortSignal,
    },
  };
};
